import { RichText, RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
interface IErrorMessage {
    errorMsg?: RichText | string;
}

export const ErrorMessage: React.FC<IErrorMessage> = ({ errorMsg }) => {
    return <RichTextComponent text={errorMsg} className='ms-search-result-container__no-results-message' />;
};
